// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import ZoomOutOutlinedSvg from "@ant-design/icons-svg/lib/asn/ZoomOutOutlined";
import AntdIcon from "../components/AntdIcon";
const ZoomOutOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: ZoomOutOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    ZoomOutOutlined.displayName = "ZoomOutOutlined";
}
export default /*#__PURE__*/ React.forwardRef(ZoomOutOutlined);
